// import { disableScroll } from '../functions/disable-scroll';
// import { enableScroll } from '../functions/enable-scroll';

(function () {
  const burger = document?.querySelector('[data-burger]');
  const menu = document?.querySelector('[data-menu]');
  const elems = document.querySelector('.sidenav');
  const menuItems = document.querySelectorAll('.nav-menu__item');
  console.log(menuItems)
  const instance = M.Sidenav.init(elems, {
    inDuration: 150,
    outDuration: 150,
    preventScrolling: false
  });

  // const menuItems = document?.querySelectorAll('[data-menu-item]');
  const overlay = document?.querySelector('[data-menu-overlay]');

  burger?.addEventListener('click', (e) => {
    burger?.classList.toggle('burger--active');
    menu?.classList.toggle('menu--active');
    overlay?.classList.toggle('visually-hidden');

    if (menu?.classList.contains('menu--active')) {
      burger?.setAttribute('aria-expanded', 'true');
      burger?.setAttribute('aria-label', 'Закрыть меню');
      // disableScroll();
    } else {
      burger?.setAttribute('aria-expanded', 'false');
      burger?.setAttribute('aria-label', 'Открыть меню');
      // enableScroll();
    }
    if (burger?.classList.contains('burger--active')) {
      elems.style.transform = "translateX(0%)";
      // burger?.classList.remove('burger--active');
      // disableScroll();
    } else {
      elems.style.transform = "translateX(-105%)";
      if (menu?.classList.contains('menu--active')) {
        burger?.classList.remove('burger--active');
      }
      // enableScroll();
    }
  });

  overlay?.addEventListener('click', () => {
    burger?.classList.toggle('burger--active');
    menu?.classList.toggle('menu--active');
    overlay?.classList.add('visually-hidden');

    if (menu?.classList.contains('menu--active')) {
      burger?.setAttribute('aria-expanded', 'true');
      burger?.setAttribute('aria-label', 'Закрыть меню');
      // disableScroll();
    } else {
      burger?.setAttribute('aria-expanded', 'false');
      burger?.setAttribute('aria-label', 'Открыть меню');
      // enableScroll();
    }
    if (burger?.classList.contains('burger--active')) {
      elems.style.transform = "translateX(0%)";
      // disableScroll();
    } else {
      elems.style.transform = "translateX(-105%)";
      if (menu?.classList.contains('menu--active')) {
        burger?.classList.remove('burger--active');
      }
      // enableScroll();
    }

  });

  [].forEach.call(menuItems, function (item) {
    item.addEventListener('click', () => {
      burger?.classList.toggle('burger--active');
      menu?.classList.toggle('menu--active');
      overlay?.classList.add('visually-hidden');

      if (menu?.classList.contains('menu--active')) {
        burger?.setAttribute('aria-expanded', 'true');
        burger?.setAttribute('aria-label', 'Закрыть меню');
        // disableScroll();
      } else {
        burger?.setAttribute('aria-expanded', 'false');
        burger?.setAttribute('aria-label', 'Открыть меню');
        // enableScroll();
      }
      if (burger?.classList.contains('burger--active')) {
        elems.style.transform = "translateX(0%)";
        // disableScroll();
      } else {
        elems.style.transform = "translateX(-105%)";
        if (menu?.classList.contains('menu--active')) {
          burger?.classList.remove('burger--active');
        }
        // enableScroll();
      }
    })
  });



  // if (burgerHeader?.classList.contains('burger--active')) {
  //   console.log(instance)
  //   console.log(burgerHeader?.classList.contains('burger--active'));
  //   console.log(elems);
  //   elems.style.transform = "translateX(-105%)";
  // }

  // menuItems?.forEach(el => {
  //   el.addEventListener('click', () => {
  //     burger?.setAttribute('aria-expanded', 'false');
  //     burger?.setAttribute('aria-label', 'Открыть меню');
  //     burger.classList.remove('burger--active');
  //     menu.classList.remove('menu--active');
  //     enableScroll();
  //   });
  // });
})();

